module.exports = __webpack_public_path__ + "img/application_bg1_m.e79ed71d.jpg";